import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table, List, ListItem, Checkbox, FormControlLabel,
    TableHead,
    TableBody, Card,
    TableCell,
    FormLabel, FormGroup, FormHelperText, Box, Chip
} from "@material-ui/core";
import ParkService from "./Locality/Service/parkService";
import * as Yup from 'yup';
import CouponService from "./Locality/Service/couponService";
import { Typography } from "../../components/Wrappers/Wrappers";
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgb(255, 107, 129)",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dialogTextField: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
    },
    couponCodeField: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px',
            textTransform: 'uppercase',
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
        },
        '& .MuiInputBase-input': {
            textTransform: 'uppercase',
        },
    },
}));

export default function Coupon() {
    const tableHeaders = ['Coupon Code', 'Coupon Name', 'Description', 'Discount Type', 'Discount Value', 'Valid From', 'Valid Until', 'Status', 'Actions'];
    const classes = useStyles();
    const [parkList, setParkList] = useState([]);
    const [parkId, setParkId] = useState("");
    const [couponList, setCouponList] = useState([]);
    const [open, setOpen] = useState(false);
    const [pg, setpg] = useState(0);
    const [rpg, setrpg] = useState(5);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editingCoupon, setEditingCoupon] = useState(null);

    const [coupon, setCoupon] = useState({
        couponCode: '',
        couponName: '',
        description: '',
        discountType: 'percentage',
        discountValue: '',
        maxUsageLimit: '',
        maxUsagePerUser: 1,
        validFrom: '',
        validUntil: '',
        isActive: true,
        parkId: '',
        profileRegistrationId: '',
        ismaxUsageLimit: false,
        isMinimumOrderAmount: false,
        minimumOrderAmount: 0,
        isApplicableUser: false,
        applicableUser: ['all']
    });

    const validationSchema = Yup.object().shape({
        couponCode: Yup.string().required('Coupon code is required'),
        couponName: Yup.string().required('Coupon name is required'),
        discountType: Yup.string().required('Discount type is required'),
        discountValue: Yup.number().required('Discount value is required').min(0, 'Discount value must be positive'),
        validUntil: Yup.date().required('Valid until date is required'),
        parkId: Yup.string().required('Park is required'),
    });

    const handleChangePage = (event, newpage) => {
        setpg(newpage);
        getCouponList(newpage, rpg);
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setrpg(newRowsPerPage);
        setpg(0);
        getCouponList(0, newRowsPerPage);
    }

    useEffect(() => {
        getCouponList();
        getParkList();
        return () => {
            setCouponList([]);
            setParkList([]);
        }
    }, []);

    const getParkList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const result = userDetails.role === "admin" ? null : userDetails.profileId;
        ParkService.addAllProfileId({ profileRegistrationId: result }).then((res) => {
            setParkList(res);
        }).catch((err) => {
            console.error('Error fetching parks:', err);
        });
    }

    const getCouponList = (page = 0, rowsPerPage = 5) => {
        setLoading(true);
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const profileRegistrationId = userDetails.role === "admin" ? null : userDetails.profileId;
        
        // Get coupons for all parks or specific park
        const params = new URLSearchParams();
        if (profileRegistrationId) {
            params.append('profileRegistrationId', profileRegistrationId);
        }
        if (parkId) {
            params.append('parkId', parkId);
        }
        params.append('page', page + 1);
        params.append('limit', rowsPerPage);

        CouponService.getAllCoupon(params).then((res) => {
            if (res && res.coupons) {
                // Filter by profileRegistrationId and parkId if needed
                let filteredCoupons = res.coupons;
                if (profileRegistrationId) {
                    filteredCoupons = filteredCoupons.filter(coupon => 
                        coupon.profileRegistrationId === profileRegistrationId
                    );
                }
                if (parkId) {
                    filteredCoupons = filteredCoupons.filter(coupon => 
                        coupon.parkId._id === parkId || coupon.parkId === parkId
                    );
                }
                
                setCouponList(filteredCoupons);
                setTotalCount(res.pagination ? res.pagination.totalCoupons : filteredCoupons.length);
            }
            setLoading(false);
        }).catch((err) => {
            console.error('Error fetching coupons:', err);
            setLoading(false);
        });
    }

    const handleOpen = () => {
        setOpen(true);
        setIsEdit(false);
        setEditingCoupon(null);
        setCoupon({
            couponCode: '',
            couponName: '',
            description: '',
            discountType: 'percentage',
            discountValue: '',
            maxUsageLimit: '',
            maxUsagePerUser: 1,
            validFrom: '',
            validUntil: '',
            isActive: true,
            parkId: '',
            profileRegistrationId: '',
            ismaxUsageLimit: false,
            isMinimumOrderAmount: false,
            minimumOrderAmount: 0,
            isApplicableUser: false,
            applicableUser: ['all']
        });
    };

    const handleClose = () => {
        setOpen(false);
        setIsEdit(false);
        setEditingCoupon(null);
    };

    const editCoupon = (coupon) => {
        setEditingCoupon(coupon);
        setIsEdit(true);
        setCoupon({
            ...coupon,
            validFrom: coupon.validFrom ? new Date(coupon.validFrom).toISOString().split('T')[0] : '',
            validUntil: coupon.validUntil ? new Date(coupon.validUntil).toISOString().split('T')[0] : '',
            parkId: coupon.parkId._id || coupon.parkId,
        });
        setOpen(true);
    }

    const deleteCoupon = (coupon) => {
        if (window.confirm('Are you sure you want to delete this coupon?')) {
            CouponService.deleteCoupon(coupon).then((res) => {
                getCouponList(pg, rpg);
            }).catch((err) => {
                console.error('Error deleting coupon:', err);
            });
        }
    };

    const formik = useFormik({
        initialValues: coupon,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.profileRegistrationId = userDetails.profileId;
            
            // Format dates
            if (values.validFrom) {
                values.validFrom = new Date(values.validFrom).toISOString();
            }
            if (values.validUntil) {
                values.validUntil = new Date(values.validUntil).toISOString();
            }

            // Handle boolean fields and their dependent values
            if (!values.ismaxUsageLimit) {
                values.maxUsageLimit = null;
            }
            if (!values.isMinimumOrderAmount) {
                values.minimumOrderAmount = 0;
            }
            if (!values.isApplicableUser) {
                values.applicableUser = ['all'];
            }

            if (isEdit && editingCoupon) {
                CouponService.upadeCoupon({ ...values, _id: editingCoupon._id }).then((res) => {
                    getCouponList(pg, rpg);
                    handleClose();
                    resetForm();
                }).catch((err) => {
                    console.error('Error updating coupon:', err);
                });
            } else {
                CouponService.creteCoupon(values).then((res) => {
                    getCouponList(pg, rpg);
                    handleClose();
                    resetForm();
                }).catch((err) => {
                    console.error('Error creating coupon:', err);
                });
            }
        },
    });

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('en-IN');
    };

    const formatCurrency = (value) => {
        return `₹${value}`;
    };

    return (
        <div>
            <PageTitle title="Coupon Management" />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget
                        title="Coupon List"
                        upperTitle
                        bodyClass="table-full-width"
                        disableWidgetMenu
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center" gap={2}>
                                <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
                                    <InputLabel>Filter by Park</InputLabel>
                                    <Select
                                        value={parkId}
                                        onChange={(e) => {
                                            setParkId(e.target.value);
                                            setpg(0);
                                            getCouponList(0, rpg);
                                        }}
                                        label="Filter by Park"
                                    >
                                        <MenuItem value="">All Parks</MenuItem>
                                        {parkList.map((park) => (
                                            <MenuItem key={park._id} value={park._id}>
                                                {park.parkName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={handleOpen}
                                style={{ backgroundColor: 'rgb(255, 107, 129)' }}
                            >
                                Add Coupon
                            </Button>
                        </Box>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {tableHeaders.map((header) => (
                                        <StyledTableCell key={header}>{header}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={tableHeaders.length} align="center">
                                            Loading...
                                        </TableCell>
                                    </TableRow>
                                ) : couponList.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={tableHeaders.length} align="center">
                                            No coupons found
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    couponList.map((coupon) => (
                                        <TableRow key={coupon._id}>
                                            <TableCell>{coupon.couponCode}</TableCell>
                                            <TableCell>{coupon.couponName}</TableCell>
                                            <TableCell>{coupon.description || '-'}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={coupon.discountType}
                                                    color={coupon.discountType === 'percentage' ? 'primary' : 'secondary'}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {coupon.discountType === 'percentage' 
                                                    ? `${coupon.discountValue}%` 
                                                    : formatCurrency(coupon.discountValue)
                                                }
                                            </TableCell>
                                            <TableCell>{formatDate(coupon.validFrom)}</TableCell>
                                            <TableCell>{formatDate(coupon.validUntil)}</TableCell>
                                            <TableCell>
                                                {coupon.isActive ? (
                                                    <CheckIcon style={{ color: '#4caf50', fontSize: '24px' }} />
                                                ) : (
                                                    <CloseIcon style={{ color: '#f44336', fontSize: '24px' }} />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <EditIcon
                                                    style={{ cursor: 'pointer', color: '#ff6b81', marginRight: '10px' }}
                                                    onClick={() => editCoupon(coupon)}
                                                />
                                                <DeleteIcon
                                                    style={{ cursor: 'pointer', color: '#f44336' }}
                                                    onClick={() => deleteCoupon(coupon)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={totalCount}
                            rowsPerPage={rpg}
                            page={pg}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>

            {/* Add/Edit Coupon Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    {isEdit ? 'Edit Coupon' : 'Add New Coupon'}
                </DialogTitle>
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Coupon Code"
                                    name="couponCode"
                                    value={formik.values.couponCode}
                                    onChange={(e) => {
                                        const upperCaseValue = e.target.value.toUpperCase();
                                        formik.setFieldValue('couponCode', upperCaseValue);
                                    }}
                                    error={formik.touched.couponCode && Boolean(formik.errors.couponCode)}
                                    helperText={formik.touched.couponCode && formik.errors.couponCode ? formik.errors.couponCode : "Will be automatically converted to uppercase"}
                                    variant="outlined"
                                    className={classes.couponCodeField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Coupon Name"
                                    name="couponName"
                                    value={formik.values.couponName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.couponName && Boolean(formik.errors.couponName)}
                                    helperText={formik.touched.couponName && formik.errors.couponName}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    name="description"
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                    multiline
                                    rows={3}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel>Discount Type</InputLabel>
                                    <Select
                                        name="discountType"
                                        value={formik.values.discountType}
                                        onChange={formik.handleChange}
                                        label="Discount Type"
                                    >
                                        <MenuItem value="percentage">Percentage</MenuItem>
                                        <MenuItem value="fixed">Fixed Amount</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Discount Value"
                                    name="discountValue"
                                    type="number"
                                    value={formik.values.discountValue}
                                    onChange={formik.handleChange}
                                    error={formik.touched.discountValue && Boolean(formik.errors.discountValue)}
                                    helperText={formik.touched.discountValue && formik.errors.discountValue}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Valid From"
                                    name="validFrom"
                                    type="date"
                                    value={formik.values.validFrom}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Valid Until"
                                    name="validUntil"
                                    type="date"
                                    value={formik.values.validUntil}
                                    onChange={formik.handleChange}
                                    error={formik.touched.validUntil && Boolean(formik.errors.validUntil)}
                                    helperText={formik.touched.validUntil && formik.errors.validUntil}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth variant="outlined" size="small">
                                    <InputLabel>Park</InputLabel>
                                    <Select
                                        name="parkId"
                                        value={formik.values.parkId}
                                        onChange={formik.handleChange}
                                        error={formik.touched.parkId && Boolean(formik.errors.parkId)}
                                        label="Park"
                                    >
                                        {parkList.map((park) => (
                                            <MenuItem key={park._id} value={park._id}>
                                                {park.parkName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Max Usage Per User"
                                    name="maxUsagePerUser"
                                    type="number"
                                    value={formik.values.maxUsagePerUser}
                                    onChange={formik.handleChange}
                                    variant="outlined"
                                    className={classes.dialogTextField}
                                    size="small"
                                />
                            </Grid> */}
                            
                            {/* Boolean Fields with Conditional Logic */}
                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="ismaxUsageLimit"
                                            checked={formik.values.ismaxUsageLimit}
                                            onChange={formik.handleChange}
                                        />
                                    }
                                    label="Enable Maximum Usage Limit"
                                />
                            </Grid>
                            {formik.values.ismaxUsageLimit && (
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Maximum Usage Limit"
                                        name="maxUsageLimit"
                                        type="number"
                                        value={formik.values.maxUsageLimit}
                                        onChange={formik.handleChange}
                                        variant="outlined"
                                    />
                                </Grid>
                            )} */}

                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="isMinimumOrderAmount"
                                            checked={formik.values.isMinimumOrderAmount}
                                            onChange={formik.handleChange}
                                        />
                                    }
                                    label="Enable Minimum Order Amount"
                                />
                            </Grid>
                            {formik.values.isMinimumOrderAmount && (
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        label="Minimum Order Amount"
                                        name="minimumOrderAmount"
                                        type="number"
                                        value={formik.values.minimumOrderAmount}
                                        onChange={formik.handleChange}
                                        variant="outlined"
                                    />
                                </Grid>
                            )} */}

                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="isApplicableUser"
                                            checked={formik.values.isApplicableUser}
                                            onChange={formik.handleChange}
                                        />
                                    }
                                    label="Enable User Type Restrictions"
                                />
                            </Grid>
                            {formik.values.isApplicableUser && (
                                <Grid item xs={12} md={6}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel>Applicable Users</InputLabel>
                                        <Select
                                            name="applicableUser"
                                            multiple
                                            value={formik.values.applicableUser}
                                            onChange={formik.handleChange}
                                            label="Applicable Users"
                                        >
                                            <MenuItem value="all">All Users</MenuItem>
                                            <MenuItem value="new">New Users</MenuItem>
                                            <MenuItem value="existing">Existing Users</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )} */}

                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="isActive"
                                            checked={formik.values.isActive}
                                            onChange={formik.handleChange}
                                        />
                                    }
                                    label="Active"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button type="submit" color="primary" variant="contained">
                            {isEdit ? 'Update' : 'Create'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
